<template>
  <div>
    <section>
      <v-app-bar
        :clipped-left="clipped"
        color="#EBEBEB"
        fixed
        nav
        elevation="0"
        app
        :class="clipped ? 'clipped' : ''"
        style="border-radius: 0px; z-index: 9;">
        <v-app-bar-nav-icon class="hidden-lg-and-up" @click.stop="drawer = !drawer"/>
        
        <v-toolbar-title 
          class="d-flex align-center"
          :style="clipped ? 'padding-left: 6px;' : ''">
          <div v-if="clipped"
            class="mr-8">
            <v-img
              @click="clipped = false"
              contain
              width="40"
              height="40"
              alt="amanata"  
              :src="Object.keys(company).length > 0 ? company.fav_icon : require('@/assets/logo/favicon.png')"
              class="ma-auto cursor-pointer">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    size="20"
                    indeterminate 
                    :color="set_color">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </div>
          
          <v-chip v-if="Object.keys(counter).length > 0"
            :color="set_color"
            style="width: 146px; height: 43px; border-radius: 50px;">
            <span
              class="body-2 white--text ml-1"
              style="font-weight: 600;">
              Quota
            </span>

            <v-spacer />

            <v-avatar
              class="body-2"
              color="#FFEB3B"
              style="position: absolute; right: 12px; color: #686868;">
              <span
                class="caption font-weight-bold">
                {{ counter.total_company_quota }}
              </span>
            </v-avatar>
          </v-chip>
          
          <v-chip v-if="Object.keys(counter).length > 0"
            color="#FFFFFF"
            class="ml-6"
            style="width: 187px; height: 43px; border-radius: 50px;">
            <span
              class="body-2 ml-1"
              style="font-weight: 600; color: #686868;">
              Terpakai
            </span>

            <v-spacer />

            <v-avatar
              class="body-2"
              color="#EBEBEB"
              style="position: absolute; right: 12px; color: #686868;">
              <span
                class="caption font-weight-bold">
                {{ counter.total_company_quota_used }}
              </span>
            </v-avatar>
          </v-chip>

          <v-chip v-if="Object.keys(counter).length > 0"
            color="#FFFFFF"
            class="ml-6"
            style="width: 187px; height: 43px; border-radius: 50px;">
            <span
              class="body-2 ml-1"
              style="font-weight: 600; color: #686868;">
              Tersedia
            </span>

            <v-spacer />

            <v-avatar
              class="body-2"
              color="#EBEBEB"
              style="position: absolute; right: 12px; color: #686868;">
              <span
                class="caption font-weight-bold">
                {{ counter.total_company_quota_sisa }}
              </span>
            </v-avatar>
          </v-chip>
        </v-toolbar-title>

        <v-spacer/>

        <div
          class="mr-4">
          <v-avatar
            size="30">
            <v-img 
              width="100%"
              height="100%"
              alt="amanata"  
              :src="require('@/assets/icon/bell.png')"
              class="ma-auto">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    size="20"
                    indeterminate 
                    :color="set_color">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-avatar>
        </div>

        <v-menu
          transition="slide-x-transition"
          bottom
          right
          offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-list 
              flat 
              dense
              color="transparent"
              style="max-width: 200px;">
              <v-list-item 
                v-bind="attrs"
                v-on="on"
                class="px-2"
                style="border-radius: 50px; background: #FFFFFF;">
                <v-list-item-avatar 
                  size="30"
                  class="mr-3">
                  <v-img 
                    width="100%"
                    height="100%"
                    alt="amanata"  
                    :src="user.image_url !== undefined && user.image_url !== '' ? user.image_url : require('@/assets/image/member_default.png')"
                    class="ma-auto">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          size="20"
                          indeterminate 
                          :color="set_color">
                        </v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title
                    class="body-2 font-weight-bold">
                    {{ user.name }}
                  </v-list-item-title>
                </v-list-item-content>

                <v-list-item-action>
                  <v-icon>mdi-menu-down</v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </template>

          <v-list>
            <v-list-item
              v-for="(item, index) in menu.right"
              :key="index"
              @click="toMenu(item)">
              <v-list-item-content
                :style="index < menu.right.length - 1 ? 'border-bottom: 2px solid #f9f9f9;' : ''">
                <v-list-item-title>
                  {{ item.title }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-app-bar>

      <v-navigation-drawer
        v-model="drawer"
        :mini-variant.sync="clipped"
        width="275"
        color="#FFFFFF"
        dark
        fixed
        app>
        <div
          class="d-flex align-center cursor-pointer pa-3 py-1 mb-4"
          style="height: 64px; background: #EBEBEB;">
          <div
            class="d-flex align-center">
            <div v-if="!clipped"
              class="d-flex align-center">
              <v-img
                contain
                width="160"
                height="40"
                alt="amanata"  
                :src="Object.keys(company).length > 0 ? company.logo : require('@/assets/logo/favicon_color.png')"
                class="ma-auto ml-1">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      size="20"
                      indeterminate 
                      :color="set_color">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </div>

            <v-spacer v-if="!clipped" />

            <v-btn v-if="!clipped"
              @click="clipped = !clipped ? true : false"
              class="mr-3"
              style="position: absolute; right: 0;"
              icon>
              <v-icon
                large
                color="black">
                mdi-pan-left
              </v-icon>
            </v-btn>
          </div>
        </div>

        <v-list
          style="height: calc(100vh - 100px); overflow-y: auto; overflow-x: hidden;">
          <div 
            v-for="(item, index) in menu.left"
            :key="index">
            <v-list-item 
              v-if="item.sub_menu.length < 1"
              :to="item.link" 
              color="transparent"
              :style="clipped ? 'padding: 0px 13px;' : ''">
              <v-list-item-avatar
                size="40"
                tile
                class="mr-4"
                :class="$route.fullPath.includes(item.link) ? '' : 'box_false'"
                :color="$route.fullPath.includes(item.link) ? set_color_rgb_down : '#FFFFFF'"
                :style="$route.fullPath.includes(item.link) ? `border: 2px solid ${set_color};` : ''"
                style="border-radius: 10px !important;">
                <v-img 
                  contain
                  width="22"
                  height="22"
                  alt="amanata"  
                  :src="item.icon"
                  class="ma-auto">
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height"
                      align="center"
                      justify="center">
                      <v-progress-circular 
                        size="20"
                        indeterminate 
                        :color="set_color">
                      </v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title
                  class="body-2"
                  :class="$route.fullPath.includes(item.link) ? '' : 'grey--text'"
                  :style="$route.fullPath.includes(item.link) ? `color: ${set_color}; font-weight: 600;` : ''">
                  {{ item.title }} 
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <div v-else>
              <v-list-group
                v-if="item.title !== 'Konfigurasi' && item.sub_menu.length > 0"
                v-model="item.active"
                :color="set_color"
                :append-icon="item.sub_menu.length > 0 ? 'mdi-pan-down' : ''"
                no-action
                :class="clipped ? 'clipped_header' : ''">
                <template v-slot:activator>
                  <v-list-item-avatar
                    size="40"
                    tile
                    class="mr-4"
                    :class="item.active ? '' : 'box_false'"
                    :color="item.active ? set_color_rgb_down : '#FFFFFF'"
                    :style="item.active ? `border: 2px solid ${set_color};` : ''"
                    style="border-radius: 10px !important;">
                    <v-img 
                      contain
                      width="22"
                      height="22"
                      alt="amanata"  
                      :src="item.icon"
                      class="ma-auto">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            size="20"
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title
                      class="body-2"
                      :class="item.active ? 'font-weight-bold' : 'grey--text'"
                      :style="item.active ? `color: ${set_color};` : ''">
                      {{ item.title }}
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
                
                <div
                  v-for="(item_sub, index_sub) in item.sub_menu"
                  :key="index_sub">
                  <v-list-item
                    v-if="item_sub.sub_child.length < 1"
                    :to="item_sub.link"
                    color="transparent"
                    style="padding-left: 73px;">
                    <v-list-item-content>
                      <v-list-item-title
                        class="body-2"
                        :class="$route.fullPath.includes(item_sub.link) ? 'font-weight-bold' : 'grey--text'"
                        :style="$route.fullPath.includes(item_sub.link) ? `color: ${set_color};` : ''">
                        {{ item_sub.title }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <div v-else>
                    <v-list-group
                      v-model="item_sub.active"
                      :color="set_color"
                      :prepend-icon="item_sub.sub_child.length > 0 ? 'mdi-pan-down' : ''"
                      no-action
                      sub-group
                      class="sub_child">
                      <template v-slot:activator>
                        <v-list-item-content>
                          <v-list-item-title
                            class="body-2"
                            :class="item_sub.active ? 'font-weight-bold' : 'grey--text'"
                            :style="item_sub.active ? `color: ${set_color};` : ''"
                            style="padding-left: 40px;">
                            {{ item_sub.title }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </template>

                      <div
                        v-for="(item_child, index_child) in item_sub.sub_child"
                        :key="index_child">
                        <v-list-item
                          :to="item_child.link"
                          color="transparent"
                          class="pl-5"
                          style="margin-left: 73px;"
                          :style="!$route.path.includes(item_child.link) ?  `border-left: 1px solid #e0e0e0;` : `border-left: 3px solid ${set_color};`">
                          <v-list-item-content>
                            <v-list-item-title
                              class="body-2"
                              :class="$route.path.includes(item_child.link) ? 'font-weight-bold' : 'grey--text'"
                              :style="$route.path.includes(item_child.link) ? `color: ${set_color};` : ''">
                              {{ item_child.title }}
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </div>
                    </v-list-group>
                  </div>
                </div>
              </v-list-group>

              <div
                v-if="item.title === 'Konfigurasi' && item.sub_menu.length > 0">
                <div
                  class="body-1 black--text text-uppercase pa-4"
                  style="font-weight: 600;">
                  <span v-if="clipped">
                    <v-img 
                      contain
                      width="22"
                      height="22"
                      alt="amanata"  
                      :src="item.icon"
                      class="ma-auto">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            size="20"
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </span>
                  
                  <span v-else>
                    {{ item.title }}
                  </span>
                </div>

                <v-list-item
                  v-for="(item_sub, index_sub) in item.sub_menu"
                  :key="index_sub"
                  :to="item_sub.link"
                  color="transparent"
                  :style="clipped ? 'padding: 0px 13px;' : ''">
                  <v-list-item-avatar
                    size="40"
                    tile
                    class="mr-4"
                    :class="$route.fullPath.includes(item_sub.link) ? '' : 'box_false'"
                    :color="$route.fullPath.includes(item_sub.link) ? set_color_rgb_down : '#FFFFFF'"
                    :style="$route.fullPath.includes(item_sub.link) ? `border: 2px solid ${set_color};` : ''"
                    style="border-radius: 10px !important;">
                    <v-img 
                      contain
                      width="22"
                      height="22"
                      alt="amanata"  
                      :src="item_sub.icon"
                      class="ma-auto">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            size="20"
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-list-item-avatar>
                  
                  <v-list-item-content>
                    <v-list-item-title
                      class="body-2"
                      :class="$route.fullPath.includes(item_sub.link) ? '' : 'grey--text'"
                      :style="$route.fullPath.includes(item_sub.link) ? `color: ${set_color}; font-weight: 600;` : ''">
                      {{ item_sub.title }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </div>
            </div>
          </div>
        </v-list>

        <!-- <v-list
          style="height: calc(100vh - 100px); overflow-y: auto; overflow-x: hidden;">
          <div 
            v-for="(item, index) in menu.left"
            :key="index">
            <v-list-item 
              v-if="item.sub_menu.length < 1"
              :to="item.link" 
              color="transparent"
              :style="clipped ? 'padding: 0px 13px;' : ''">
              <v-list-item-avatar
                size="40"
                tile
                class="mr-4"
                :class="item.link.split('/')[1] === $route.fullPath.split('/')[1] ? '' : 'box_false'"
                :color="item.link.split('/')[1] === $route.fullPath.split('/')[1] ? set_color_rgb_down : '#FFFFFF'"
                :style="item.link.split('/')[1] === $route.fullPath.split('/')[1] ? `border: 2px solid ${set_color};` : ''"
                style="border-radius: 10px !important;">
                <v-img 
                  contain
                  width="22"
                  height="22"
                  alt="amanata"  
                  :src="item.icon"
                  class="ma-auto">
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height"
                      align="center"
                      justify="center">
                      <v-progress-circular 
                        size="20"
                        indeterminate 
                        :color="set_color">
                      </v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title
                  class="body-2"
                  :class="item.link.split('/')[1] === $route.fullPath.split('/')[1] ? '' : 'grey--text'"
                  :style="item.link.split('/')[1] === $route.fullPath.split('/')[1] ? `color: ${set_color}; font-weight: 600;` : ''">
                  {{ item.title }} 
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-group
              v-if="item.title !== 'Konfigurasi' && item.sub_menu.length > 0"
              v-model="item.active"
              :color="set_color"
              :append-icon="item.sub_menu.length > 0 ? 'mdi-pan-down' : ''"
              no-action
              :class="clipped ? 'clipped_header' : ''">
              <template v-slot:activator>
                <v-list-item-avatar
                  size="40"
                  tile
                  class="mr-4"
                  :class="item.active ? '' : 'box_false'"
                  :color="item.active ? set_color_rgb_down : '#FFFFFF'"
                  :style="item.active ? `border: 2px solid ${set_color};` : ''"
                  style="border-radius: 10px !important;">
                  <v-img 
                    contain
                    width="22"
                    height="22"
                    alt="amanata"  
                    :src="item.icon"
                    class="ma-auto">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          size="20"
                          indeterminate 
                          :color="set_color">
                        </v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title
                    class="body-2"
                    :class="item.active ? 'font-weight-bold' : 'grey--text'"
                    :style="item.active ? `color: ${set_color};` : ''">
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item
                v-for="(item_sub, index_sub) in item.sub_menu"
                :key="index_sub"
                :to="item_sub.link"
                color="transparent">
                <v-list-item-content>
                  <v-list-item-title
                    class="body-2"
                    :class="item_sub.link === $route.fullPath ? 'font-weight-bold' : 'grey--text'"
                    :style="item_sub.link === $route.fullPath ? `color: ${set_color};` : ''">
                    {{ item_sub.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>

            <div
              v-if="item.title === 'Konfigurasi' && item.sub_menu.length > 0">
              <div
                class="body-1 black--text text-uppercase pa-4"
                style="font-weight: 600;">
                <span v-if="clipped">
                  <v-img 
                    contain
                    width="22"
                    height="22"
                    alt="sergap"  
                    :src="item.icon"
                    class="ma-auto">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          size="20"
                          indeterminate 
                          :color="set_color">
                        </v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </span>
                
                <span v-else>
                  {{ item.title }}
                </span>
              </div>

              <v-list-item
                v-for="(item_sub, index_sub) in item.sub_menu"
                :key="index_sub"
                :to="item_sub.link"
                color="transparent"
                :style="clipped ? 'padding: 0px 13px;' : ''">
                <v-list-item-avatar
                  size="40"
                  tile
                  class="mr-4"
                  :class="item_sub.link.split('/')[2] === $route.fullPath.split('/')[2] ? '' : 'box_false'"
                  :color="item_sub.link.split('/')[2] === $route.fullPath.split('/')[2] ? set_color_rgb_down : '#FFFFFF'"
                  :style="item_sub.link.split('/')[2] === $route.fullPath.split('/')[2] ? `border: 2px solid ${set_color};` : ''"
                  style="border-radius: 10px !important;">
                  <v-img 
                    contain
                    width="22"
                    height="22"
                    alt="amanata"  
                    :src="item_sub.icon"
                    class="ma-auto">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          size="20"
                          indeterminate 
                          :color="set_color">
                        </v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-list-item-avatar>
                
                <v-list-item-content>
                  <v-list-item-title
                    class="body-2"
                    :class="item_sub.link === $route.fullPath ? '' : 'grey--text'"
                    :style="item_sub.link === $route.fullPath ? `color: ${set_color}; font-weight: 600;` : ''">
                    {{ item_sub.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </div>
          </div>
        </v-list> -->
      </v-navigation-drawer>
    </section>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        clipped: false,
        drawer: true,
        total: 0,
        menu: {
          right: [
            {
              title: 'Profile',
              type: 'profile',
              link: '/profile?menu=profile'
            },
            {
              title: 'Keluar',
              type: 'logout',
              link: '#'
            }
          ],
          left: []
        }
      }
    },
    components: {
      Empty: () => import(/* webpackPrefetch: true */ '@/components/empty')
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      token () {
        return this.$store.state.token
      },
      reload () {
        return this.$store.state.reload
      },
      company () {
        return this.$store.state.company
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r+93}, ${g+120}, ${b+12})`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.2)`
      },
      set_color_rgb_soft () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.05)`
      },

      counter () {
        return this.$store.state.counter
      },
    },
    created () {
      
    },
    mounted () {
      const debounce = (fn) => {
        let frame;
        return (...params) => {
          if (frame) { 
            cancelAnimationFrame(frame)
          }
          frame = requestAnimationFrame(() => {
            fn(...params)
          })
        } 
      }

      const storeScroll = () => {
        document.documentElement.dataset.scroll = window.scrollY
      }

      document.addEventListener('scroll', debounce(storeScroll), { passive: true })
      storeScroll()

      this.menu.left = this.$store.state.menu

      this.fetch()
    },
    methods: {
      async fetch () {
        await get('admin/config')
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            res.results.data[0].color = JSON.parse(res.results.data[0].color)

            TokenService.saveCompany(JSON.stringify(res.results.data[0]))

            this.$store.commit("setCompany", res.results.data[0])
            
            if (res.results.data[0].color.length > 0) {
              res.results.data[0].color.map((obj) => {
                if (obj.active) {
                  TokenService.saveColor(obj.hex)

                  this.$store.commit("setColor", obj.hex)
                }
              })
            } else {
              TokenService.saveColor('#7550e1')

              this.$store.commit("setColor", '#7550e1')
            }

            this.styles()

            this.fetchCounter()
          }
        })
      },

      async fetchCounter () {
        await get('admin/dashboard/counter')
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            let item = res.results.data

            let counter = {
              total_company_quota: item.total_company_quota,
              total_company_quota_used: item.total_company_quota_used,
              total_company_quota_sisa: item.total_company_quota - item.total_company_quota_used
            }

            TokenService.saveCounter(JSON.stringify(counter))

            this.$store.commit("setCounter", counter)
          }
        })
      },

      async toMenu (item) {
        if (item.type === 'logout') {
          TokenService.removeToken()
              
          window.location = '/login'
        } else {
          this.$router.push(item.link)
        }
      },

      styles () {
        let style = document.createElement('style')
          
        // RESET STYLESHEET TO AUTO
        style.innerHTML = `
          .v-data-table table .v-data-table-header {
            color: white;
            // background-color: ${this.set_color}; !important;
          }
          .v-data-table table > thead > tr > th {
            // background: ${this.set_color};
          }

          .v-data-table table > tbody .v-data-table__selected .v-input--selection-controls__input {
            // color: ${this.set_color};
          }
          .v-data-table table > tbody .v-input--selection-controls__input .v-icon {
            // color: ${this.set_color};
          }

          ::-webkit-scrollbar-thumb{
            border-radius: 10px;
            background-color: ${this.set_color};
          }

          #iw-container .iw-title {
            font-family: 'Open Sans Condensed', sans-serif;
            font-size: 22px;
            font-weight: 400;
            padding: 10px;
            background-color: ${this.set_color};
            color: white;
            margin: 0;
            border-radius: 2px 2px 0 0;
          }

          .v-slide-group__prev .v-icon {
            color: ${this.set_color}; !important;
          }

          .v-slide-group__next .v-icon {
            color: ${this.set_color}; !important;
          }

          .table-grid table > thead > tr > th:nth-child(1) {
            left: 0; 
            z-index: 5;
            // background: ${this.set_color};
          }

          .v-data-table table > tbody > tr:hover .text-start, table > tbody > tr:hover .text-center,  table > tbody > tr:hover .text-end {
            cursor: pointer;
            // background-color: ${this.set_color_rgb_up} !important;
            background-color: #E0E0E0 !important;
            border-radius: 0px !important;
          }
          .v-data-table__selected .text-start, .v-data-table__selected .text-center, .v-data-table__selected .text-end {
            // background-color: ${this.set_color_rgb_up} !important;
            background-color: #E0E0E0 !important;
            border-radius: 0px !important;
          }
        `

        // ADD TO APPENDCHILD
        document.head.appendChild(style)
      }
    }
  }
</script>

<style>
  .sub .v-list-item {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }

  .clipped .v-toolbar__content {
    padding-left: 8px;
  }

  .v-navigation-drawer--mini-variant {
    width: 68px !important;
  }

  .clipped_header .v-list-group__header {
    padding: 0px 13px;
  }
</style>